import styled from "@emotion/styled";

export const SelectedItem = styled.div`
  display: flex;
  align-items: center;
  h3 {
    margin: 0;
  }
`;
